import React, { Component } from 'react';
import { Table, Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { categoryActions as actions } from '../../actions';
import { categoryConstants } from '../../constants';
import '../../content/css/PredictTextModal.css';
import LoadingListener from '../../helpers/loadingListener';
import { LoadingIcon } from '../LoadingIcon';

class PredictTextModal extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            text: this.props.text,
            show: false
        };

        this.loadingListener = new LoadingListener([categoryConstants.TEST_MODELS_REQUEST]);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.text !== prevProps.text && this.props.text !== "") {
            this.setState({ text: this.props.text });
            this.handleShow();
        }

        if (this.props.show != prevProps.show && this.props.show != this.state.show) {
            this.setState({ show: this.props.show });
        }
    }

    handleClose = () => {
        this.setState({ show: false });
        if (this.props.onClose) this.props.onClose();
    }

    handleShow = () => {
        this.setState({ show: true });
    }

    handleTestModels = () => {
        this.props.testModels(this.state.text);
    }

    handleTextChange = e => {
        var text = e.target.value;
        this.setState({ text });
    }

    getRows() {
        if (this.props.modelsResults === undefined || this.props.modelsResults.length === 0) return [];

        let results = this.props.modelsResults.filter(x => x.confirmationType === "Yes");
        if (results.length === 0) return (<tr className="model-result-list-row">
            <td>None</td>
            <td></td>
        </tr>);

        return this.props.modelsResults.filter(x => x.confirmationType === "Yes").map((model, i) => (
            <tr className="model-result-list-row">
                <td>{model.categoryName !== null ? model.categoryName : model.categoryId}</td>
                <td>{model.categoryCode}</td>
                <td>{model.modelCreated}</td>
                <td>{model.confirmationType}</td>
            </tr>
        ));
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);

        return (
            <div>
                <Modal className="predict-text-modal" scrollable={true} show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Which concepts does the text belong to?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <textarea key="editor" value={this.state.text} onChange={this.handleTextChange} />
                        {isLoading &&
                            <LoadingIcon />
                        }

                        {!isLoading &&
                            <Table className="model-result-list" striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>Concept</th>
                                        <th>Code</th>
                                        <th>Model Created</th>
                                        <th>Result</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.getRows()}
                                </tbody>
                            </Table>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleTestModels}>Test</Button>
                        <Button onClick={this.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default connect(
    state => state.category,
    dispatch => bindActionCreators(actions, dispatch)
)(PredictTextModal);


// WEBPACK FOOTER //
// ./src/components/DocumentViewer/PredictTextModal.js